/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemDeleteResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCartItemDeleteResponse } from '../../../../models/index.js';
// @ts-ignore
import { AddonRequestBuilderRequestsMetadata, type AddonRequestBuilder } from './addon/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/item/{cartItemId}
 */
export interface WithCartItemItemRequestBuilder extends BaseRequestBuilder<WithCartItemItemRequestBuilder> {
    /**
     * The addon property
     */
    get addon(): AddonRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemDeleteResponse>}
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemDeleteResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithCartItemItemRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/item/{cartItemId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCartItemItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCartItemItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    addon: {
        requestsMetadata: AddonRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCartItemItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCartItemItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemDeleteResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
